import { Button } from "../ui/button";
import { Server } from "lucide-react";
import usePlanInfoStore from "@/store/zustand/planInfoStore";

export default function CustomMCPUpsell() {
  const setShowUpgradeModal = usePlanInfoStore(
    (state) => state.setShowUpgradeModal,
  );

  return (
    <div className="border border-border rounded-lg p-8 text-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <div className="h-12 w-12 rounded-full bg-muted flex items-center justify-center">
          <Server className="h-6 w-6 text-muted-foreground" />
        </div>
        <div>
          <p className="text-sm text-muted-foreground max-w-md">
            Custom MCP servers require a Scale plan or higher. Upgrade your plan
            to connect to your own MCP servers.
          </p>
        </div>
        <Button variant="primary" onClick={() => setShowUpgradeModal(true)}>
          Upgrade Plan
        </Button>
      </div>
    </div>
  );
}
